import React from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import is_null from "../../helpers/is_null";
import { axiosget, axiospost } from "../../helpers/httprequest";
import Loader from "../../components/Loader";
// import PrintHeader from "../../Print/PrintHeader";
// import PrintStudentCardProfile from "../../Print/PrintStudentCardProfile";
import ErrorResponse from "../../components/ErrorResponse";
import "./PrintRegistration.css"; // New CSS file
import ReceiptHeader from "../PaymentReceipts/ReceiptHeader";

const PrintRegistration = () => {
  const [progress, setProgress] = React.useState(null);
  const { id } = useParams();
  const queryClient = useQueryClient();

  // Data fetching logic
  const cachedData = queryClient.getQueryData(["VerticalTimeline"]);
  const { data, isLoading } = useQuery({
    queryKey: ["VerticalTimeline"],
    queryFn: async () => {
      const response = await axiosget("ms_progression_profile/courseform");
      return response?.data;
    },
    enabled: !cachedData,
  });

  const {
    data: register,
    error: errRegister,
  } = useQuery({
    queryKey: ["courseRegistrationPrint"],
    queryFn: async () => {
      const response = await axiospost("ms_course_registration/courseform", progress);
      return response?.data;
    },
    enabled: !!progress,
  });

  const timelineData = cachedData || data;
  const sortedData = timelineData?.sort((a, b) => a.step - b.step);

  React.useEffect(() => {
    if (id && sortedData) {
      const stepObject = sortedData.find((item) => item._id === id);
      setProgress(stepObject);
    }
  }, [id, sortedData]);

  if (is_null(id)) {
    window.close();
    return null;
  }

  // Calculate total credits
  const totalCredits = register?.registration?.reduce((sum, course) => sum + (course.credit || 0), 0) || 0;

  return (
    <div className="receipt-container">
      {isLoading && <Loader />}
      {errRegister && <ErrorResponse type="danger" message={`Error: ${errRegister.message}`} />}
      {register?.type !== undefined && <ErrorResponse type="danger" message={register?.message} />}

      {register?.type === undefined && (
        <div className="print-content">
          {/* Header Section */}
          {register?.session && (
            <div className="print-header1-section">
              <ReceiptHeader session={register?.session} />
            </div>
          )}
          <div className="receipt">
            {/* Receipt Header */}
            <div className="receipt-header">
              <h2>OFFICIAL COURSE REGISTRATION FORM</h2>
              <div className="receipt-meta">
                <span>Date Generated: {new Date().toLocaleDateString()}</span>
              </div>
            </div>
            {/* Student Profile Section */}
            <div className="receipt-section">
              <div className="student-info" style={{ padding: "15px" }}>
                <div className="info-column">
                  <div className="info-row">
                    <span className="info-label">Reg. Number:</span>
                    <span className="info-value">{register?.student?.studentid}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Full Name:</span>
                    <span className="info-value">
                      {register?.student?.firstname} {register?.student?.middlename} {register?.student?.lastname}
                    </span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">School:</span>
                    <span className="info-value">{register?.programme?.department?.college?.name}</span>
                  </div>
                </div>
                <div className="info-column">
                  <div className="info-row">
                    <span className="info-label">Department:</span>
                    <span className="info-value">{register?.programme?.department?.name}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Programme:</span>
                    <span className="info-value">{register?.student?.programme?.name}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Session:</span>
                    <span className="info-value">{register?.session?.name}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Courses Table */}
            <div className="courses-table-section">
              <table className="courses-table">
                <thead>
                  <tr>
                    <th>SN</th>
                    <th>Course Code</th>
                    <th>Course Name</th>
                    <th>Credit</th>
                  </tr>
                </thead>
                <tbody>
                  {register?.registration?.map((course, index) => (
                    <tr key={`course-row-${index}`}>
                      <td>{index + 1}</td>
                      <td>{course?.courseinfo?.code}</td>
                      <td>{course?.courseinfo?.name}</td>
                      <td>{course?.credit}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Total Credits */}
            <div className="total-credits-section">
              <h3>TOTAL CREDIT UNIT REGISTERED FOR SEMESTER: {totalCredits}</h3>
            </div>

            {/* Signatures Section */}
            <div className="signatures-section">
              {/* First Row - Student and HOD Side by Side */}
              <div className="signature-row">
                {/* Student Signature */}
                <div className="signature-block">
                  <div className="signature-title">ATTESTATION/DECLARATION</div>
                  <div className="signature-line"></div>
                  <div className="signature-label">Student's Signature</div>
                </div>

                {/* HOD Signature */}
                <div className="signature-block">
                  <div className="signature-title">CERTIFICATION BY HEAD OF DEPARTMENT</div>
                  <div className="signature-line"></div>
                  <div className="signature-label">Head of Department</div>
                </div>
              </div>
            </div>

            {/* Print Footer */}
            <div className="print-footer">
              <p>This is an official document generated by the management information system</p>
              <p className="print-timestamp">Printed on: {new Date().toLocaleString()}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PrintRegistration;
